'use client';

import { useEffect } from 'react';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { useIdleIntercom } from '@/shared/hooks/use-intercom-widget';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

/**
 * Client-only side effects for /ai-ats: the page-view event and the Intercom
 * widget. A null island so the page itself stays a server component.
 */
export const AiAtsPageEffects = () => {
	useIdleIntercom();

	useEffect(() => {
		emitMixpanelEvent(mixpanelEvents.VIEWED_AI_ATS_PAGE, {
			feature: MIXPANEL_APP_FEATURES.AI_ATS_PAGE,
		});
	}, []);

	return null;
};
